import { CardTemplateProps } from 'medere-ui-framework'
import { useMemo } from 'react'
import { KitListItemDTO } from '../../../dto/kits/KitsDTO'
import LocationActionMenu, { LocationActionItem } from '../../Location/tabs/components/LocationActionMenu'

export interface KitsCardActionsProps {
  onEdit: (item: KitListItemDTO) => void
  onDelete: (item: KitListItemDTO) => void
}

type KitsListCardProps = CardTemplateProps & KitsCardActionsProps & {
  entity: KitListItemDTO
}

function normalizeValue(value: string | null | undefined, emptyText = 'Sin datos') {
  const normalized = String(value ?? '').trim()
  return normalized !== '' ? normalized : emptyText
}

export default function KitsListCard({
  entity,
  onEdit,
  onDelete,
}: Readonly<KitsListCardProps>) {
  const cardMenuItems: LocationActionItem[] = useMemo(() => [
    {
      label: 'Editar',
      icon: 'pi pi-file-edit',
      action: () => onEdit(entity),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: () => onDelete(entity),
    },
  ], [entity, onDelete, onEdit])

  return (
    <article className='kits-mobile-card'>
      <div className='kits-mobile-card-header'>
        <h3 className='kits-mobile-card-title'>{normalizeValue(entity.description, 'Sin descripción')}</h3>
        <LocationActionMenu
          items={cardMenuItems}
          buttonClassName='p-button-text kits-mobile-card-menu-btn'
          ariaLabel='Opciones del kit'
          panelClassName='kits-action-menu-panel'
          contentClassName='w-64'
        />
      </div>

      <div className='kits-mobile-card-body'>
        <div className='kits-mobile-card-row'>
          <span className='kits-mobile-card-key'>Tipo de kit</span>
          <span className='kits-mobile-card-value'>{normalizeValue(entity.stockItemsKitTypeName)}</span>
        </div>
        <div className='kits-mobile-card-row'>
          <span className='kits-mobile-card-key'>Estado</span>
          <span className='kits-mobile-card-value'>{entity.active ? 'Activo' : 'Inactivo'}</span>
        </div>
      </div>
    </article>
  )
}
